import AppGraphQl from "js/graphql/resolvers/types.resolver";
import { GQLParamBuilder } from "../../../../helpers";
import { useState, useEffect, useRef } from "react";
import { ModelMapResult, OperationMapResult } from "../helpers";

const getQueryPromise = (client, op, vars) => {
  const opBuilder = new GQLParamBuilder(client);

  opBuilder.setOperation(op);

  const variables = { ...vars };

  opBuilder.setVariables({ ...variables });

  return opBuilder.exec();
};

const fetchDetails = async (client, op, variables) => {
  try {
    const opBuilder = new GQLParamBuilder(client);

    opBuilder.setOperation(op);

    opBuilder.setVariables({ ...variables });

    const detailsFound = await opBuilder.exec();

    return detailsFound;
  } catch (error) {
    console.log(error.message);
  }
};

export const useGetDetails = ({ op, client, variables }) => {
  const [details, setDetails] = useState();
  const prevOpRef = useRef();
  const prevClientRef = useRef();
  const prevVariablesRef = useRef();

  useEffect(
    () => {
      // Verificar si realmente han cambiado los parámetros
      const opChanged = prevOpRef.current !== op;
      const clientChanged = prevClientRef.current !== client;
      const variablesChanged =
        JSON.stringify(prevVariablesRef.current) !== JSON.stringify(variables);

      if (!opChanged && !clientChanged && !variablesChanged) {
        return; // No hacer nada si no han cambiado
      }

      // Actualizar las referencias
      prevOpRef.current = op;
      prevClientRef.current = client;
      prevVariablesRef.current = variables;

      const getDetails = async () => {
        if (!op) return;

        const detailsFound = await fetchDetails(client, op, variables);

        if (detailsFound) setDetails(detailsFound);
      };

      getDetails();
    },
    [op, client, variables]
  );

  return details;
};
